module.exports = __webpack_public_path__ + "img/logo-icon.b508735f.svg";